import type {
  NumericalGapPolicy,
  NumericalThresholdGapPolicy,
  ThresholdGapPolicy,
  TimeGapPolicy,
} from '../types/gap-policy.js';
import { convertTimeThreshold } from './timeThreshold.js';

/**
 * Gets the threshold value in milliseconds.
 *
 * If gapPolicy === 'gap' or the threshold is invalid, it fallbacks to 0 (in that way, every gap will remain as gap)
 *
 * @param gapPolicy - given GapPolicy
 * @returns
 */
export function getThresholdValue(gapPolicy: TimeGapPolicy) {
  return isThresholdGapPolicy(gapPolicy)
    ? (convertTimeThreshold(gapPolicy.threshold) ?? 0)
    : 0;
}

/**
 * Type guard to ensure we are working with the ThresholdGapPolicy.
 *
 * @param gapPolicy - given GapPolicy
 * @returns
 */
function isThresholdGapPolicy(
  gapPolicy: TimeGapPolicy,
): gapPolicy is ThresholdGapPolicy {
  return typeof gapPolicy === 'object' && 'threshold' in gapPolicy;
}

export function getNumericalThresholdValue(gapPolicy: NumericalGapPolicy) {
  return isNumericalThresholdGapPolicy(gapPolicy) &&
    Number.isFinite(gapPolicy.threshold)
    ? gapPolicy.threshold
    : 0;
}

function isNumericalThresholdGapPolicy(
  gapPolicy: NumericalGapPolicy,
): gapPolicy is NumericalThresholdGapPolicy {
  return typeof gapPolicy === 'object' && 'threshold' in gapPolicy;
}
